<template>
	<form ref="contactform" enctype="multipart/form-data" method="post" class="contact-form" @submit.prevent="submit()">
		<div v-if="state.errors.length">
			<div v-for="(error, idx) in state.errors" :key="idx" class="error">
				{{ $t(error) }}
			</div>
		</div>
		<div v-for="field in formRef" :key="field.name">
			<checkbox-group
				v-if="field.edittype === 'checkboxgroup'"
				v-model:checkboxgroup="field.value"
				:field="field"
			/>
			<date-field v-else-if="field.name.endsWith('Date')" v-model:datefield="field.value" :field="field" />
			<form-field v-else :field="field" />
		</div>
		<input type="submit" class="button button-cta action" :value="$t('formSubmit')" />
	</form>
</template>

<script setup>
const props = defineProps({
	form: { type: Array, default: () => [] },
	name: { type: String, default: 'contact' },
	extraQueryData: { type: Object, default: null },
});

const state = useState('contactform', () => ({
	errors: [],
}));

const formRef = ref([...props.form]);
const contactform = ref(null);
const { submitForm, prepareSubmitData, setErrors, clearErrors, resetForm } = useForm();

const submit = async () => {
	clearErrors(state, formRef);

	const data = prepareSubmitData(formRef);

	const result = await submitForm(data, props.name, props.extraQueryData);
	if (result.status !== 'success') {
		setErrors(state, result, formRef.value);
		window.scroll({
			top: (contactform.value?.offsetTop || 0) - 150,
			left: 0,
			behavior: 'smooth',
		});
	} else {
		resetForm(formRef, contactform, state);
		await navigateTo(result.redirect);
	}
};

const { $installRecaptcha } = useNuxtApp();
onMounted(() => {
	$installRecaptcha();
});
</script>

<style lang="scss" scoped>
form {
	margin: 40px 0 0;

	.error {
		display: block;
		margin: 0 0 10px;
	}

	:deep(input:not([type='checkbox'], [type='radio'], [type='submit'])),
	:deep(select),
	:deep(textarea) {
		color: #555;
		width: 100%;
		max-width: 500px;
		padding: 20px;
		border: none;
		margin: 0 0 25px;
		box-shadow: 0 0 5px rgb(0 0 0 / 10%);
		font-size: 13px;
		font-family: var(--body-font-family);
	}

	:deep(input:not([disabled], [type='submit'])),
	:deep(select),
	:deep(textarea) {
		background-color: var(--primary-background-color);
	}

	:deep(select) {
		background: url('~/assets/images/icon-form-dropdown.png') no-repeat var(--primary-background-color);
		background-position: right 15px top 50%;
		appearance: none;
	}

	input[type='submit'] {
		width: auto;
	}

	:deep(textarea) {
		min-height: 140px;
		max-width: 100%;
	}

	:deep(.mx-input) {
		height: auto;
		font-size: unset;
		color: unset;

		&:focus,
		&:hover {
			border-color: transparent;
		}

		&:focus {
			outline: revert;
		}
	}

	.button {
		width: auto;
		appearance: none;
		cursor: pointer;
		outline: none;
		border: none;
		padding: 20px 25px;
	}
}
</style>
